import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data
                    ? (() => {
                        const idx = props.data.title.indexOf(" - ");
                        if (idx !== -1) {
                          return (
                            <>
                              {props.data.title.slice(0, idx)} -<br />
                              {props.data.title.slice(idx + 3)}
                            </>
                          );
                        }
                        return props.data.title;
                      })()
                    : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
